import React from 'react';
import styled from 'styled-components';
import Title from "../components/Title";
import {
    Card,
    Col,
    Empty,
    Row,
    Space,
    Spin, Typography,
} from "antd";
import SubBanner from "../components/SubBanner";
import ContentContainer from "../components/ContentContainer";
import Section from "../components/Section";
import {useParams} from "react-router-dom";
import SubTitle from "../components/SubTitle";
import CardRecentNews from "../components/CardRecentNews";
import Image from "../components/Image";
import DateNews from "../components/DateNews";
import CKEditorContent from "../components/CKEditorContent";
import {UserOutlined} from "@ant-design/icons";
import useDefaultRequest from "../hooks/useDefaultRequest";
import ENDPOINTS from "../constants/endpoints";
import {formatPath, ROUTES} from "../constants/PathRoutes";

const StyledSection = styled(Section)`
    padding-top: 24px;
    padding-bottom: 24px;
`

const StyledVideoDiv = styled.div`
    & * {
        max-width: 100%;
    }
`

export default function News() {
    const {slug} = useParams()

    const {data: news, isLoading} = useDefaultRequest({
        url: formatPath(ENDPOINTS.NEWS_DETAIL_PUBLIC, {slug}),
        dataDefault: {},
        redirectRoute: ROUTES.BLOG,
        dependence: [slug]
    })

    const {data: recentNews} = useDefaultRequest({
        url: ENDPOINTS.NEWS_DETAIL_LATEST_PUBLIC,
        dataDefault: [],
        dependence: [slug]
    })

    return (
        <>
            <SubBanner title={'Notícia'}/>
            <StyledSection>
                <ContentContainer>
                    <Spin spinning={isLoading}>
                        <Row gutter={[24, 24]}>


                            <Col xs={24}>
                                <Card title={
                                    <Space direction={'vertical'} size={0}>
                                        <Title color={'black'} style={{whiteSpace: "wrap", marginBottom:0}} sty>{news.title}</Title>
                                        <Typography.Text style={{fontSize:18}} type={'secondary'} >{news.preview}</Typography.Text>
                                        <Space size={24}>
                                            <Space>
                                                <UserOutlined/>
                                                <span>{news?.author_fullname}</span>
                                            </Space>
                                            <DateNews value={news.created_at}/>
                                        </Space>
                                    </Space>
                                }>
                                      <Image src={news.image}/>
                                    <CKEditorContent content={news.content}/>
                                </Card>
                            </Col>

                            {news.video && (
                                <Col xs={24}>
                                    <StyledVideoDiv
                                        dangerouslySetInnerHTML={{__html: news.video}}
                                    />
                                </Col>
                            )}

                            <Col xs={24} style={{marginBottom: 0}}>
                                <SubTitle>Notícias recentes</SubTitle>
                            </Col>

                            {recentNews.length > 0 ? (
                                recentNews.map(({image, created_at, title, slug, preview}) => (
                                    <Col xs={24} md={12} lg={6} key={slug}>
                                        <CardRecentNews
                                            slug={slug}
                                            date={created_at}
                                            title={title}
                                            image={image}
                                            resume={preview}
                                        />
                                    </Col>
                                ))
                            ) : (
                                <Col xs={24}>
                                    <Empty description={'Sem notícias recentes'}/>
                                </Col>
                            )}
                        </Row>
                    </Spin>
                </ContentContainer>
            </StyledSection>
        </>
    )
}